import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import categories from "../../data/categories";
import { ArrowRight } from "lucide-react";

const CategorySection = () => {
  const navigate = useNavigate();
  return (
    <section className="pt-10 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row sm:items-center sm:justify-between max-w-7xl mx-auto mb-8 px-4 gap-3"
        >
          <div>
            <h2 className="text-2xl font-bold text-gray-900 text-center sm:text-left">
              Shop by Categories
            </h2>

            <p className="text-gray-600 mt-1 text-center sm:text-left">
              Explore our range of healthcare equipment
            </p>
          </div>

          <button onClick={() => navigate("/shop")} className="group flex items-center justify-center gap-2 text-green-600 font-medium hover:text-green-700 transition">
            See All
            <span className="transition-transform duration-300 group-hover:translate-x-1">
              <ArrowRight size={18} />
            </span>
          </button>
        </motion.div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 justify-items-center">
          {categories.map((category, index) => {
            const Icon = category.icon;

            return (
              <motion.div
                key={category.id}
                onClick={() => navigate(`/shop`)}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex flex-col items-center justify-center text-center cursor-pointer group"
              >
                <div className="w-20 h-20 rounded-full bg-green-100 p-5 flex items-center justify-center mb-3 group-hover:bg-green-600 transition">
                  <Icon
                    size={28}
                    className="text-green-600 group-hover:text-white transition"
                  />
                </div>

                <h3 className="text-lg font-semibold text-gray-900 text-center">
                  {category.title}
                </h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;

// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { ArrowRight } from "lucide-react";

// import useCategories from "../../hooks/useCategories";

// import {
//   Accessibility,
//   Bed,
//   HeartPulse,
//   Stethoscope,
//   Activity,
//   ShieldCheck,
// } from "lucide-react";


// // Keep UI icons in frontend
// const categoryIcons = {
//   Wheelchairs: Accessibility,
//   "Hospital Beds": Bed,
//   "Patient Care": HeartPulse,
//   "Medical Equipment": Stethoscope,
//   "Diagnostic Equipment": Activity,
//   Safety: ShieldCheck,
// };


// const CategorySection = () => {

//   const navigate = useNavigate();

//   const {
//     categories,
//     loading,
//     error,
//   } = useCategories();



//   if (loading) {
//     return (
//       <section className="py-20 text-center">
//         Loading categories...
//       </section>
//     );
//   }



//   if (error) {
//     return (
//       <section className="py-20 text-center">
//         Failed to load categories.
//       </section>
//     );
//   }



//   return (
//     <section className="pt-10 pb-20 bg-white">

//       <div className="max-w-7xl mx-auto px-6">


//         {/* Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           viewport={{ once: true }}
//           className="flex flex-col sm:flex-row sm:items-center sm:justify-between max-w-7xl mx-auto mb-8 px-4 gap-3"
//         >

//           <div>

//             <h2 className="text-2xl font-bold text-gray-900 text-center sm:text-left">
//               Shop by Categories
//             </h2>


//             <p className="text-gray-600 mt-1 text-center sm:text-left">
//               Explore our range of healthcare equipment
//             </p>

//           </div>



//           <button
//             onClick={() => navigate("/shop")}
//             className="group flex items-center justify-center gap-2 text-green-600 font-medium hover:text-green-700 transition"
//           >

//             See All

//             <span className="transition-transform duration-300 group-hover:translate-x-1">
//               <ArrowRight size={18}/>
//             </span>

//           </button>


//         </motion.div>




//         {/* Categories Grid */}
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 justify-items-center">


//           {categories.map((category,index)=>{


//             const Icon =
//               categoryIcons[category.title] || Activity;



//             return (

//               <motion.div

//                 key={category._id}

//                 onClick={() =>
//                   navigate(
//                     `/shop?category=${category.title}`
//                   )
//                 }

//                 initial={{
//                   opacity:0,
//                   y:40
//                 }}

//                 whileInView={{
//                   opacity:1,
//                   y:0
//                 }}

//                 transition={{
//                   duration:0.5,
//                   delay:index * 0.1
//                 }}

//                 viewport={{
//                   once:true
//                 }}

//                 className="flex flex-col items-center justify-center text-center cursor-pointer group"

//               >


//                 <div className="
//                   w-20
//                   h-20
//                   rounded-full
//                   bg-green-100
//                   p-5
//                   flex
//                   items-center
//                   justify-center
//                   mb-3
//                   group-hover:bg-green-600
//                   transition
//                 ">


//                   <Icon
//                     size={28}
//                     className="
//                       text-green-600
//                       group-hover:text-white
//                       transition
//                     "
//                   />


//                 </div>



//                 <h3 className="
//                   text-lg
//                   font-semibold
//                   text-gray-900
//                 ">
//                   {category.title}
//                 </h3>


//               </motion.div>

//             );


//           })}


//         </div>


//       </div>

//     </section>
//   );
// };


// export default CategorySection;
